// We hold the URLs to access (mostly images) from our storage

import { Version } from "../helpers/version";

// TODO:JJ This could be generic - perhaps we should do that?

export type CodeBundle = {
  version: Version;
  files: string[];
};

export type StorageFactory = {
  tedUrl: string;
  imagineUrl: string;
  skillSuperNovaUrl: string;
  skillShootingStarUrl: string;
  skillRocketUrl: string;
  osttraspinnerUrl: string;
};
